import { defineStore } from 'pinia'

export const AppsStore = defineStore('apps_list', {
    state: () => {
        return { apps_list: null }
    },
    actions: {
        get() {
            return this.apps_list
        },
        set(value) {
            this.apps_list = value
        }
    },
})